import React from 'react';
import Icon from './Icon';
import { colors } from '~/styles';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  font-size: 1rem;
  color: ${colors.grey40};
`;

function SyncIcon({ ...props }) {
  return <StyledIcon icon="sync" {...props} />;
}

export default SyncIcon;
